import dayjs from 'dayjs'

function timeframeFormat (timeframe) {
  let dayInfo = []
  if (timeframe) {
    switch (timeframe) {
      case 'day':
        dayInfo = getDayjsFormatByTimeframe(0)
        break
      case 'week':
        dayInfo = getDayjsFormatByTimeframe(6)
        break
      case 'month':
        dayInfo = getDayjsFormatByTimeframe(30)
        break
      default:
        dayInfo = getDayjsFormatByTimeframe(0)
        break
    }
  }
  //   if (this.dates.length) {
  //     const date1 = dayjs(this.dates[1]).add(dayjs().get('hour'), 'hour')
  //     const date2 = dayjs(this.dates[0]).add(dayjs().get('hour'), 'hour')
  //     const dateDiff = date1.diff(date2, 'day')
  //     dayInfo = [date1, dateDiff]
  //   }
  return dayInfo
}

function getDayjsFormatByTimeframe (days) {
  const date1 = dayjs(new Date())
  const date2 = dayjs(new Date()).subtract(days, 'day')
  const dateDiff = date1.diff(date2, 'day')
  return [date1, dateDiff]
}

export default function getDateTimeFormat (timeframe) {
  return timeframeFormat(timeframe)
}
